import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environments';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private router: Router,
    private http: HttpClient
  ) { }

  login(email: any, password: any) {
    return this.http.post<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/login`, { email: email, password: password })
      .pipe(map(user => {
        localStorage.setItem(`${environment.appName}` + 'user', user.data.access_token);
        return user;
      }));
  }

  logout() {
    localStorage.removeItem(`${environment.appName}` + 'user');
    this.router.navigate(['/login']);
  }


  // schemelists
  getSchemeList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/schemes/list?search=` + search + '&page=' + page);
  }

  getschemebyid(schemeId: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/schemes/${schemeId}`)
  }


  // customer lists
  getCustomerList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/users/list?search=` + search + '&page=' + page);
  }

  // user scheme deatils
  getUserSchemeList(search: any, page: any, startDate: any, endDate: any, branch: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/user-schemes/payment-list?search=` + search + '&page=' + page + '&startDate=' + startDate + '&endDate=' + endDate + '&branch=' + branch);
  }

  getuserschemebyid(userSchemeId: any, startDate: any, endDate: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/user-schemes/installment-list/${userSchemeId}?startDate=` + startDate + '&endDate=' + endDate)
  }

  downloadUserSchemeExcel(userSchemeId: any, startDate: any, endDate: any, branch: any) {
    const file = this.http
      .get<Blob>(
        `${environment.apiUrl}${environment.apiPrefix}/admin/user-schemes/userscheme-list-excel-download/${userSchemeId}?startDate=` + startDate + '&endDate=' + endDate + '&branch=' + branch,
        { responseType: "blob" as "json" }
      )
      .pipe(
        map((user) => {
          return user;
        })
      );
    return file;
  }

  downloadPaymentExcel(search: any, startDate: any, endDate: any, branch: any) {
    const file = this.http.get<Blob>(`${environment.apiUrl}${environment.apiPrefix}/admin/user-schemes/installment-list/excel-download?search=` + search + '&startDate=' + startDate + '&endDate=' + endDate + '&branch=' + branch, { responseType: 'blob' as 'json' }).pipe(map(user => {
      return user
    }));
    return file;
  }

  // feedback lists
  getfeddbackList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/fact-and-feeds/list?search=` + search + '&page=' + page);
  }

  getsfeddbackbyid(Id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/fact-and-feeds/${Id}`)
  }

  addFeddback(title: any, subtitle: any, description: any,
    imageFile: any,
  ) {
    var formData = new FormData();
    formData.append("title", title)
    formData.append("subtitle", subtitle)
    formData.append("description", description)
    if (imageFile) {
      formData.append("imageFile", imageFile);
    }
    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/fact-and-feeds/add`,
      formData
    );
  }

  updateFeedback(
    Id: string,
    title: any,
    subtitle: any,
    description: any,
    imageFile: any,
  ) {
    var formData = new FormData()
    formData.append("title", title)
    formData.append("subtitle", subtitle)
    formData.append("description", description)
    if (imageFile) {
      formData.append("imageFile", imageFile);
    }
    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/fact-and-feeds/update/${Id}`,
      formData
    );
  }

  deleteFeedback(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/fact-and-feeds/delete/${Id}`
    );
  }


  // branches
  getBranchList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/list?search=` + search + '&page=' + page);
  }

  getBranchId(Id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/list/${Id}`)
  }
  getBranchById(Id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/branch/view`)
  }

  addBranch(name: any, branch: any, mobile: any, password: any
  ) {
    var formData = new FormData();
    formData.append("name", name)
    formData.append("branch", branch)
    formData.append("mobile", mobile)
    formData.append("password", password)

    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/add`,
      formData
    );
  }

  addBranchData(title: any,
    contactNo: any,
    whatsappNo: any,
    address: string,
    email: string,
    from: string,
    to: string,
    latitude: string,
    longitude: string,
    city: string,
    state: string,
    district: string, photo: any
  ) {
    var formData = new FormData();
    formData.append("title", title)
    formData.append("contactNo", contactNo)
    formData.append("whatsappNo", whatsappNo)
    formData.append("address", address)
    formData.append("email", email)
    formData.append("from", from)
    formData.append("to", to)
    formData.append("latitude", latitude)
    formData.append("longitude", longitude)
    formData.append("city", city)
    formData.append("state", state)
    formData.append("district", district)
    formData.append("image", photo)
    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/branch/add`,
      formData
    );
  }

  updateBranch(
    Id: string,
    name: any,
    branch: any, mobile: any, password: any
  ) {
    var formData = new FormData()
    formData.append("name", name)
    formData.append("branch", branch)
    formData.append("mobile", mobile)
    formData.append("password", password)

    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/update/${Id}`,
      formData
    );
  }

  updateBranchData(id: any, title: any,
    contactNo: any,
    whatsappNo: any,
    address: string,
    email: string,
    from: string,
    to: string,
    latitude: string,
    longitude: string,
    city: string,
    state: string,
    district: string, photo: any
  ) {
    var formData = new FormData();
    formData.append("title", title)
    formData.append("contactNo", contactNo)
    formData.append("whatsappNo", whatsappNo)
    formData.append("address", address)
    formData.append("email", email)
    formData.append("from", from)
    formData.append("to", to)
    formData.append("latitude", latitude)
    formData.append("longitude", longitude)
    formData.append("city", city)
    formData.append("state", state)
    formData.append("district", district)
    if (photo) {
      formData.append("image", photo)
    }
    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/branch/update/` + id,
      formData
    );
  }
  updateGoldRate(data: any
  ) {

    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/gold-rates/update`,
      data
    );
  }

  deleteBranch(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/delete/${Id}`
    );
  }

  deleteBranchData(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/branch/delete/${Id}`
    );
  }

  getBranchDropdown() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/abharna-api/branch-list`).pipe(map(user => user))
  }

  getgoldrates(search: string, page: number) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/gold-rates/view`).pipe(map(user => user))
  }

  getBranchData(search: string, page: number) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/branch/list?search=` + search + '&page=' + page).pipe(map(user => user))
  }

  resetAdminPassword(password: string) {
    const formData = {
      password: password,
    };
    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/update-password`,
      formData
    );
  }

  // Offers

  getOffersList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/offers/list?search=` + search + '&page=' + page);
  }

  getOffersbyid(Id: any) {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/offers/${Id}`)
  }

  addOffers(title: any,
    imageFile: any,
  ) {
    var formData = new FormData();
    formData.append("title", title)
    if (imageFile) {
      formData.append("imageFile", imageFile);
    }
    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/offers/add`,
      formData
    );
  }

  getBannerList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/banner/list?search=` + search + '&page=' + page);
  }

  getGiftCardList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/gift-cards/list?search=` + search + '&page=' + page);
  }

  getImagesList(search: any, page: any) {
    return this.http.get(`${environment.apiUrl}${environment.apiPrefix}/admin/explore-images/list??search=` + search + '&page=' + page);
  }

  addBanners(title: any, imageFile: any) {
    const formData = new FormData();
    formData.append("name", title);

    // if (imageFile.length) {
    //   for (let i = 0; i < imageFile.length; i++) {
    formData.append("image", imageFile); // ✅ Append each file
    //   }
    // }

    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/banner/add`,
      formData
    );
  }

  addGiftVoucher(title: any,denominations:any,description:string, imageFile: any) {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("denominations", JSON.stringify(denominations));
  if (imageFile.length) {
      for (let i = 0; i < imageFile.length; i++) {
    formData.append("images", imageFile[i]); // ✅ Append each file
      }
     }

    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/gift-cards/add`,
      formData
    );
  }

  addImages(imageFile: any) {
    const formData = new FormData();


    if (imageFile.length) {
      for (let i = 0; i < imageFile.length; i++) {
        formData.append("image", imageFile[i]); // ✅ Append each file
      }
    }

    return this.http.post<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/explore-images/add`,
      formData
    );
  }


  deleteBanner(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/banner/delete/${Id}`
    );
  }

  deleteGiftVoucher(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/gift-cards/delete/${Id}`
    );
  }

  deleteImages(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/explore-images/delete/${Id}`
    );
  }

  updateOffers(
    Id: string,
    title: any,
    imageFile: any,
  ) {
    var formData = new FormData()
    formData.append("title", title)
    if (imageFile) {
      formData.append("imageFile", imageFile);
    }
    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/offers/update/${Id}`,
      formData
    );
  }

  updateBanner(
    Id: string,
    title: any, status: any,
    imageFile: any,
  ) {
    var formData = new FormData()
    formData.append("name", title)
    formData.append("status", status)
    if (imageFile) {
      formData.append("image", imageFile);
    }
    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/banner/update/${Id}`,
      formData
    );
  }

  updateGiftVoucher(
    Id: string,
    title: any, denominations:any,description:any,status: any,
    imageFile: any,
  ) {
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("denominations", JSON.stringify(denominations));
  if (imageFile.length) {
      for (let i = 0; i < imageFile.length; i++) {
    formData.append("images", imageFile[i]); // ✅ Append each file
      }
     }

    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/gift-cards/update/${Id}`,
      formData
    );
  }

  updateImages(
    Id: string,
    status: any,
    imageFile: any,
  ) {
    var formData = new FormData()

    if (imageFile && imageFile.length) {
      for (let i = 0; i < imageFile.length; i++) {
        formData.append("image", imageFile[i]); // ✅ Append each file
      }
    }
    formData.append("status", status);

    return this.http.put<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/explore-images/update/${Id}`,
      formData
    );
  }

  deleteOffers(Id: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${environment.apiPrefix}/admin/offers/delete/${Id}`
    );
  }

  // dashboard
  schemeDashboard() {
    return this.http.get<any>(`${environment.apiUrl}${environment.apiPrefix}/admin/dashboard/counts`).pipe(map(user => user));
  }

}
